import { render, staticRenderFns } from "./SiftBEDate.vue?vue&type=template&id=37d2afe9&scoped=true&"
import script from "./SiftBEDate.vue?vue&type=script&lang=js&"
export * from "./SiftBEDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d2afe9",
  null
  
)

export default component.exports